<template>
  <div class="home">
    <Navbar></Navbar>

    <ProjectBanner></ProjectBanner>

    <!-- HERO SECTION -->
    <section class="section-hero">
      <div class="container mt-3">
        <div class="row justify-content-center">
          <div class="col-md-8 text-center">
            <h1 class="text-hero fw-500 mb-3">Easy peasy
              <span class="text-primary highlight-secondary">color generators</span>
              <span class="text-secondary">.</span>
            </h1>
            <p class="paragraph text-muted mt-4">
              Create gradients, palettes, save one of the many color schemes or use our amazing tools.
              <span class="d-none d-lg-inline-block">For everyone who needs a color</span>
            </p>
            <p v-if="user.loggedIn" class="subtitle-1 text-primary mb-3">Hi {{ user.data.displayName }}! 👋</p>
            <p v-else class="subtitle-1 text-primary mb-3">Sign up now and experience Colorffy
              today!</p>

            <router-link v-if="user.loggedIn" to="/palettes"
                         class="btn btn-primary btn-micint-rotate btn-xs-full-width shadow-0dp ripple p-3">
              Explore palettes
              <i class="material-icons-outlined">&#xe87a;</i>
            </router-link>
            <router-link v-else to="/sign-up"
                         class="btn btn-primary btn-micint-x btn-xs-full-width shadow-0dp ripple p-3">Sign Up for
              free
              <i class="material-icons-outlined">&#xea77;</i>
            </router-link>
            <router-link to="/gradients"
                         class="btn btn-primary-outline btn-micint-x btn-xs-full-width ripple ripple-primary p-3">
              Explore gradients
              <i class="material-icons-outlined">&#xe5c8;</i>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <div class="container mb-3">

      <!-- GRADIENTS AND PALETTES BUTTONS -->
      <div class="row mb-3">
        <div class="col-md-6 mb-3">
          <router-link to="/palettes">
            <div class="card shadow-sm translate-up card-home-palette border-radius-25">
              <div class="card-body text-center my-2">
                <h2 class="fw-500 typography-headline-sm mb-0">Palettes</h2>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-md-6 mb-3">
          <router-link to="/gradients">
            <div class="card shadow-sm translate-up card-home-gradient border-radius-25">
              <div class="card-body text-center my-2">
                <h2 class="fw-500 typography-headline-sm mb-0">Gradients</h2>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <!-- NEW GRADIENTS TEXT SECTION -->
      <div class="row align-items-center mb-3">
        <div class="col-6 col-md-6">
          <h3 class="typography-headline-sm">New gradients</h3>
        </div>
        <div class="col-6 col-md-6 text-end">
          <router-link to="/gradients" class="btn btn-link ripple ripple-primary">
            <i class="material-icons-outlined">&#xe5d3;</i>
            View more
          </router-link>
        </div>
      </div>

      <!-- NEW GRADIENTS SECTION -->
      <div v-if="!gradients || (gradients && gradients.length < 1)" class="col-md-12 text-center mt-3">
        <LoadingState title="Loading gradients..."
                      subtitle="If nothing is loading, please check if Javascript it's enabled in your browser or try using a VPN"></LoadingState>
      </div>
      <GradientsList :gradients="gradients" :isDisplay="'d-none'"></GradientsList>

      <!-- CTA TEXT SECTION -->
      <ProjectsCTA></ProjectsCTA>

      <div class="row mb-5">
        <div class="col-md-12">
          <div class="card card-outline border-radius-25">
            <div class="card-body text-center text-md-start p-md-5">
              <div class="row">
                <div class="col-md-6 align-self-center">
                  <h4 class="fw-bold typography-headline-md text-gradient mb-4 mb-md-0">Awesome color tools in <br> just
                    one place </h4>
                </div>
                <div class="col-md-6 align-self-center">
                  <router-link to="/gradient/generator"
                               class="btn btn-primary-light btn-round btn-flat ripple ripple-dark py-3 px-5">Create a
                    gradient
                  </router-link>
                  <a href="https://mixgradients.dev/?ref=colorffy"
                     class="btn btn-secondary-light btn-round btn-flat ripple ripple-dark py-3 px-5">Mesh/Mix gradients
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SupportMe></SupportMe>

    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/includes/Footer";
import Navbar from "@/components/includes/Navbar";
import GradientsList from "@/components/gradients/GradientsList";
import ProjectsCTA from "@/components/cta/ProjectsCTA";
import LoadingState from "@/components/empty-states/LoadingState";
import firebase from 'firebase/app'
import 'firebase/firestore'
import {mapGetters} from 'vuex'
import SupportMe from "@/components/cta/SupportMe";
import ProjectBanner from "@/components/cta/ProjectBanner";

export default {
  name: 'Home',
  metaInfo: {
    title: 'Home',
  },
  components: {
    ProjectBanner,
    SupportMe,
    LoadingState,
    ProjectsCTA,
    GradientsList,
    Navbar,
    Footer
  },
  data() {
    return {
      gradients: [],
      db: firebase.firestore()
    }
  },
  mounted() {
    this.fetchGradients()
  },
  methods: {
    async fetchGradients() {
      try {
        const gradientsSnap = await this.db
            .collection('gradients')
            .orderBy('createdAt', "desc")
            .limit(4)
            .get()

        this.gradients = gradientsSnap.docs.map(doc => {
          return {id: doc.id, ...doc.data()}
        })
      } catch (e) {
        console.log(e.message)
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
  }
}
</script>
